module.exports = __webpack_public_path__ + "img/logo.f4a60674.png";